module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_5012.52002f18.png";